<template>
	<div class="app-container">
		<div class="filter-container">
			<el-form ref="queryForm" inline :model="listQuery" @submit.native.prevent>
				<el-form-item prop="address">
					<el-input v-model="listQuery.name" placeholder="请输入场地名称" clearable @change="SearchData"
						@keyup.enter.native="SearchData" />
				</el-form-item>
				<el-form-item prop="type">
					<el-select v-model="listQuery.site_id" placeholder="请选择门店名称" filterable clearable>
						<el-option v-for="item in siteList" :key="item.value" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="type">
					<el-select v-model="listQuery.type" placeholder="请选择门店类型" :disabled="!listQuery.site_id" clearable
						@change="SearchData">
						<el-option v-for="item in dictionary" :key="item.value" :label="item.label" :value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item prop="status">
					<el-select v-model="listQuery.status" placeholder="请选择场地状态" clearable @change="SearchData">
						<el-option label="启用" value="1"></el-option>
						<el-option label="停用" value="0"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" icon="el-icon-search" @click="SearchData">搜索</el-button>
					<el-button icon="el-icon-refresh" @click="resetQuery">重置</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!--动作组-->
		<div class="action-container">
			<el-button-group>
				<!-- 弹窗层编辑 -->
				<el-button v-auth="'Space.create'" class="action-item" type="primary" icon="el-icon-edit"
					@click="HandleCreate">添加</el-button>
				<el-button v-auth="'Space.delete'" class="action-item" icon="el-icon-delete" @click="BatchDelete">删除</el-button>

			</el-button-group>
		</div>
		<!--表开始-->
		<el-table ref="singleTable" v-loading="listLoading" :data="list" border fit highlight-current-row
			style="width: 100%" @sort-change="sortChange">
			<!--列开始-->
			<el-table-column type="selection"></el-table-column>
			<el-table-column type="index" label="序号" width="55" :index="indexMethod" align="center" />
			<el-table-column align="center" prop="site_name" label="门店名称"> </el-table-column>
			<el-table-column align="center" prop="name" label="场地名称 "> </el-table-column>
			<el-table-column align="center" prop="status" label="开启状态 " width="150">
				<template slot-scope="{ row }">
					<el-switch v-model="row.status" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="停用"
						@change="changeState(row)" />
				</template>
			</el-table-column>
			<el-table-column align="center" prop="type_name" label="场地类型 "> </el-table-column>
			<el-table-column align="center" prop="create_time" label="创建时间 "> </el-table-column>
			<el-table-column align="center" prop="" label="操作" class-name="action" width="500">
				<template slot-scope="scopes">
					<el-button v-auth="'SpaceVideo.browse'" icon="el-icon-upload" type="success" size="mini"
						@click="uploadVideo(scopes.row)">上传视频</el-button>
					<el-button v-auth="'SpaceSerial.browse'" icon="el-icon-video-camera" type="info" size="mini"
						@click="uploadserial(scopes.row)">设备管理</el-button>
					<el-button v-auth="'Space.set'" icon="el-icon-money" type="warning" size="mini"
						@click="goDatePrice(scopes.row)">价格设置</el-button>
					<el-button v-auth="'Space.update'" icon="el-icon-edit" type="primary" size="mini"
						@click="HandleUpdate(scopes.row)">编辑</el-button>
					<el-button v-auth="'Space.delete'" icon="el-icon-delete" size="mini" type="danger"
						@click="RowDelete(scopes.row)">删除</el-button>
				</template>
			</el-table-column>
			<!--列结束-->
		</el-table>
		<!--分页-->
		<pagination v-show="total>0" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.limit"
			@pagination="loadData" />
		<!--弹窗编辑/新增窗体-->
		<el-dialog :title="dialogStatus=='create'?'新增':'编辑'" :visible.sync="dialogFormVisible" width="86%" top="4vh"
			custom-class="space-edit-dialog">
			<el-form ref="dataForm" :rules="rules" :model="temp" label-position="left" label-width="110px"
				style="width: 100%;">
				<el-form-item label="门店名称" prop="site_id">
					<el-select v-model="temp.site_id" placeholder="请选择门店名称" filterable clearable style="width: 100%;">
						<el-option v-for="item in siteList" :key="item.value" :value="item.id" :label="item.name"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="场地名称" prop="name">
					<el-input v-model="temp.name" maxlength="6" show-word-limit placeholder="请输入场地名称" />
				</el-form-item>
				<el-form-item label="开启状态" prop="status">
					<el-switch v-model="temp.status" active-color="#13ce66" :active-value="1" :inactive-value="0" active-text="启用"
						inactive-text="停用"></el-switch>
				</el-form-item>
				<el-form-item label="场地类型" prop="type">
					<el-select v-model="temp.type" placeholder="请选择场地类型" style="width: 100%;" :disabled="!temp.site_id">
						<el-option v-for="item in Tempdictionary" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item v-if="showTimePriceSection" label="基础价格设置">
					<div class="basic-price-panel">
						<p class="basic-price-hint">按星期设置各时段普通价与会员价，系统将按预约日期自动匹配对应星期价格。</p>
						<div class="weekday-bar">
							<div v-for="d in weekdayList" :key="d.value"
								:class="['weekday-pill', { active: activeWeekday === d.value, isWeekend: d.weekend }]"
								@click="activeWeekday = d.value">
								<span class="weekday-label">{{ d.label }}</span>
								<span v-if="d.weekend" class="weekend-badge">周末</span>
							</div>
						</div>
						<div class="batch-card">
							<div class="batch-title">批量设置</div>
							<div class="batch-row">
								<span class="batch-label">普通价（元）</span>
								<el-input-number v-model="batchNormal" :min="0" :max="10000" :precision="2" :step="1"
									controls-position="right" placeholder="如 150" class="batch-input" />
								<span class="batch-label">会员价（元）</span>
								<el-input-number v-model="batchVip" :min="0" :max="10000" :precision="2" :step="1"
									controls-position="right" placeholder="如 120" class="batch-input" />
								<el-button type="primary" plain size="small" @click="applyBatchToCurrentDay">应用到当天</el-button>
								<el-button type="primary" size="small" @click="applyBatchToAllDays">应用到每天</el-button>
							</div>
						</div>
						<div class="day-title">
							<span class="day-title-main">{{ currentWeekdayTitle }} · 价格配置</span>
							<span class="day-title-sub">设置该天各时段的普通价与会员价</span>
						</div>
						<el-table :data="currentDaySlots" border stripe size="small" class="price-table"
							:header-cell-style="{ background: '#f0f9f4', color: '#303133' }">
							<el-table-column label="时间段" min-width="160" align="center">
								<template slot-scope="{ row }">
									<el-tag type="info" effect="plain">{{ row.start_time }} — {{ row.end_time }}</el-tag>
								</template>
							</el-table-column>
							<el-table-column label="普通用户价格（元）" align="center" min-width="200">
								<template slot-scope="{ row }">
									<el-input-number v-model="row.normal_price" :min="0" :max="10000" :precision="2" :step="0.5"
										controls-position="right" style="width: 100%; max-width: 220px;" />
								</template>
							</el-table-column>
							<el-table-column label="会员用户价格（元）" align="center" min-width="200">
								<template slot-scope="{ row }">
									<el-input-number v-model="row.vip_price" :min="0" :max="10000" :precision="2" :step="0.5"
										controls-position="right" style="width: 100%; max-width: 220px;" />
								</template>
							</el-table-column>
						</el-table>
					</div>
				</el-form-item>
				<el-form-item label="排序" prop="order_no">
					<el-input-number v-model="temp.order_no" :min="1" :max="99999" />
					<p class="tishi">排序越小，小程序展示越靠前</p>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogFormVisible = false">取消</el-button>
				<el-button type="primary" @click="ConfirmData">保存</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import api from '@/api/site/space' // 和数据交互相关写在api 方便复用
	import siteapi from '@/api/site/site' // 和数据交互相关写在api 方便复用
	import Pagination from '@/components/Pagination' // 分页 给予 el-pagination 的二次封装
	import commonList from '@/utils/commonList'
	import dict_data from '@/api/system/dict_data'

	export default {
		name: 'Space',
		components: {
			Pagination
		},
		filters: {},
		mixins: [commonList],
		data() {
			return {
				api,
				rules: {
					site_id: [{
						required: true,
						message: '请选择门店',
						trigger: 'blur,change'
					}],
					name: [{
						required: true,
						message: '请输入场地名称',
						trigger: 'blur,change'
					}],
					type: [{
						required: true,
						message: '请选择场地类型',
						trigger: 'blur,change'
					}]
				},
				temp: {},
				listQuery: {
					page: 1,
					limit: 10,
					order: 'DESC',
					sort: 'id',
					site_id: '',
					name: '',
					type: '',
					status: ''
				},
				siteList: [],
				changeone: 1,
				dictionary: [],
				Tempdictionary: [],
				showTimePriceSection: false,
				isLoadingTimeSlots: false,
				activeWeekday: 1,
				weekdayList: [{
						value: 1,
						label: '周一',
						weekend: false
					},
					{
						value: 2,
						label: '周二',
						weekend: false
					},
					{
						value: 3,
						label: '周三',
						weekend: false
					},
					{
						value: 4,
						label: '周四',
						weekend: false
					},
					{
						value: 5,
						label: '周五',
						weekend: false
					},
					{
						value: 6,
						label: '周六',
						weekend: true
					},
					{
						value: 7,
						label: '周日',
						weekend: true
					}
				],
				batchNormal: null,
				batchVip: null
			}
		},
		computed: {
			currentDaySlots() {
				if (!this.temp.basic_price_weeks || !this.temp.basic_price_weeks[this.activeWeekday]) {
					return []
				}
				return this.temp.basic_price_weeks[this.activeWeekday]
			},
			currentWeekdayTitle() {
				const f = this.weekdayList.find(w => w.value === this.activeWeekday)
				return f ? f.label : ''
			}
		},
		watch: {
			'listQuery.site_id': {
				handler(newValue, oldValue) {
					if (newValue !== oldValue || newValue === '') {
						this.listQuery.type = ''
						this.SearchData()
					}
					if (newValue !== '' && newValue !== null) {
						this.getTypeList(newValue)
					}
				}
			},
			'temp.site_id': {
				handler(newValue, oldValue) {
					if (this.changeone === 1) {
						this.temp.type = ''
					}
					this.changeone = 1
					if (newValue !== '' && newValue != null) {
						this.getTempTypeList(newValue)
						this.loadTimeSlotsForSite(newValue)
					} else {
						this.showTimePriceSection = false
						this.$set(this.temp, 'basic_price_weeks', {})
					}
				}
			}
		},
		created() {
			this.loadData()
			this.siteListSearch()
		},
		methods: {
			HandleUpdate(row) {
				this.changeone = 2
				this.temp = Object.assign({}, row)
				this.dialogStatus = 'update'
				this.dialogFormVisible = true
				this.activeWeekday = 1
				this.batchNormal = null
				this.batchVip = null

				this.$nextTick(() => {
					if (this.temp.id) {
						api.Detail(this.temp.id).then(response => {
							if (response.code === 200 && response.data) {
								const detailData = response.data
								if (detailData.type) {
									detailData.type = detailData.type.toString()
								}
								Object.keys(detailData).forEach(key => {
									if (key !== 'basic_price_weeks' && key !== 'time_prices') {
										this.$set(this.temp, key, detailData[key])
									}
								})
								const bw = detailData.basic_price_weeks
								const hasWeeksObj = bw && typeof bw === 'object' && !Array.isArray(bw) && Object.keys(bw)
									.length > 0
								if (hasWeeksObj) {
									this.normalizeBasicPriceWeeks(bw)
									const slotsOk = this.temp.basic_price_weeks[1] && this.temp.basic_price_weeks[1].length
									this.showTimePriceSection = !!slotsOk
									if (!slotsOk && this.temp.site_id) {
										this.loadTimeSlotsForSite(this.temp.site_id)
									}
								} else if (detailData.time_prices && detailData.time_prices.length > 0) {
									this.expandLegacyTimePricesToWeeks(detailData.time_prices)
									this.showTimePriceSection = true
								} else if (this.temp.site_id) {
									this.loadTimeSlotsForSite(this.temp.site_id)
								}
							}
						}).catch(() => {
							if (this.temp.site_id) {
								this.loadTimeSlotsForSite(this.temp.site_id)
							}
						})
					}
				})
			},
			normalizeBasicPriceWeeks(raw) {
				const w = {}
				for (let d = 1; d <= 7; d++) {
					const day = raw[d] || raw[String(d)]
					w[d] = (day || []).map(slot => ({
						start_time: slot.start_time,
						end_time: slot.end_time,
						normal_price: parseFloat(slot.normal_price) || 0,
						vip_price: parseFloat(slot.vip_price) || 0
					}))
				}
				this.$set(this.temp, 'basic_price_weeks', w)
			},
			expandLegacyTimePricesToWeeks(timePrices) {
				const base = timePrices.map(item => ({
					start_time: item.start_time,
					end_time: item.end_time,
					normal_price: parseFloat(item.normal_price) || 0,
					vip_price: parseFloat(item.vip_price) || 0
				}))
				const weeks = {}
				for (let d = 1; d <= 7; d++) {
					weeks[d] = JSON.parse(JSON.stringify(base))
				}
				this.$set(this.temp, 'basic_price_weeks', weeks)
			},
			uploadVideo(data) {
				this.$router.push({
					path: '/site/video',
					query: {
						id: data.id,
						site_id: data.site_id
					}
				})
			},
			uploadserial(data) {
				this.$router.push({
					path: '/site/serial',
					query: {
						id: data.id,
						site_id: data.site_id
					}
				})
			},
			goDatePrice(row) {
				this.$router.push({
					path: '/site-extra/space_date_price',
					query: {
						space_id: row.id,
						site_id: row.site_id,
						space_name: row.name
					}
				})
			},
			siteListSearch() {
				siteapi.getList().then((response) => {
					this.siteList = response.data
				})
			},
			getTypeList(id) {
				dict_data
					.getAppointList({
						code: 'mdlx',
						siteid: id
					})
					.then((response) => {
						this.dictionary = response.data
					})
			},
			getTempTypeList(id) {
				dict_data
					.getAppointList({
						code: 'mdlx',
						siteid: id
					})
					.then((response) => {
						this.Tempdictionary = response.data
						this.$forceUpdate()
					})
			},
			changeState(row) {
				api.ChangeStatus({
					id: row.id,
					status: row.status
				}).then(response => {
					this.$notify({
						title: '成功',
						message: response.msg,
						type: 'success'
					})
				})
			},
			resetTemp() {
				this.temp = {
					id: undefined,
					order_no: 99999,
					name: '',
					status: 1,
					type: '',
					site_id: '',
					basic_price_weeks: {}
				}
				this.showTimePriceSection = false
				this.activeWeekday = 1
				this.batchNormal = null
				this.batchVip = null
			},
			initBasicPriceWeeksFromSlots(slots) {
				const base = slots.map(s => ({
					start_time: s.start_time,
					end_time: s.end_time,
					normal_price: parseFloat(s.normal_price) || 0,
					vip_price: parseFloat(s.vip_price) || 0
				}))
				const weeks = {}
				for (let d = 1; d <= 7; d++) {
					weeks[d] = JSON.parse(JSON.stringify(base))
				}
				this.$set(this.temp, 'basic_price_weeks', weeks)
				this.activeWeekday = 1
			},
			loadTimeSlotsForSite(siteId) {
				if (!siteId) {
					this.showTimePriceSection = false
					this.$set(this.temp, 'basic_price_weeks', {})
					return
				}
				this.isLoadingTimeSlots = true
				api.GetTimeSlotsBySite(siteId).then(response => {
					if (response.code === 200) {
						this.initBasicPriceWeeksFromSlots(response.data || [])
						this.showTimePriceSection = true
					}
				}).catch(error => {
					const errorMsg = error.msg || error.message || '获取时间段失败'
					if (errorMsg.includes('请先设置门店营业时间') || errorMsg.includes('营业时间')) {
						this.$message.warning(errorMsg)
					} else {
						this.$message.error(errorMsg)
					}
					this.showTimePriceSection = false
					this.$set(this.temp, 'basic_price_weeks', {})
				}).finally(() => {
					this.isLoadingTimeSlots = false
				})
			},
			applyBatchToCurrentDay() {
				if (this.batchNormal == null && this.batchVip == null) {
					this.$message.warning('请至少填写普通价或会员价')
					return
				}
				const slots = this.temp.basic_price_weeks && this.temp.basic_price_weeks[this.activeWeekday]
				if (!slots || !slots.length) {
					return
				}
				slots.forEach(slot => {
					if (this.batchNormal != null) {
						slot.normal_price = this.batchNormal
					}
					if (this.batchVip != null) {
						slot.vip_price = this.batchVip
					}
				})
				this.$message.success('已应用到当天')
			},
			applyBatchToAllDays() {
				if (this.batchNormal == null && this.batchVip == null) {
					this.$message.warning('请至少填写普通价或会员价')
					return
				}
				if (!this.temp.basic_price_weeks) {
					return
				}
				for (let d = 1; d <= 7; d++) {
					const slots = this.temp.basic_price_weeks[d]
					if (!slots) continue
					slots.forEach(slot => {
						if (this.batchNormal != null) {
							slot.normal_price = this.batchNormal
						}
						if (this.batchVip != null) {
							slot.vip_price = this.batchVip
						}
					})
				}
				this.$message.success('已应用到周一至周日全部时段')
			},
			ConfirmData() {
				if (this.showTimePriceSection && this.temp.basic_price_weeks) {
					const dayLabels = ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日']
					for (let d = 1; d <= 7; d++) {
						const slots = this.temp.basic_price_weeks[d]
						if (!slots || !slots.length) {
							this.$message.error(`${dayLabels[d]}价格数据不完整`)
							return
						}
						for (let i = 0; i < slots.length; i++) {
							const slot = slots[i]
							if (slot.normal_price === null || slot.normal_price === '' || slot.normal_price === undefined) {
								slot.normal_price = 0
							}
							if (slot.vip_price === null || slot.vip_price === '' || slot.vip_price === undefined) {
								slot.vip_price = 0
							}
						}
					}
				}

				if (this.dialogStatus === 'create') {
					this.CreateData()
				} else {
					this.UpdateData()
				}
			}
		}
	}
</script>

<style scoped>
	.basic-price-panel {
		padding: 12px 16px 8px;
		background: linear-gradient(180deg, #f6fbf8 0%, #fff 32%);
		border: 1px solid #e4efe8;
		border-radius: 10px;
	}

	.basic-price-hint {
		margin: 0 0 14px;
		font-size: 13px;
		color: #606266;
		line-height: 1.5;
	}

	.weekday-bar {
		display: flex;
		flex-wrap: wrap;
		gap: 8px;
		margin-bottom: 16px;
	}

	.weekday-pill {
		display: inline-flex;
		align-items: center;
		gap: 6px;
		padding: 8px 14px;
		border-radius: 20px;
		cursor: pointer;
		border: 1px solid #dcdfe6;
		background: #fff;
		transition: all 0.2s;
		font-size: 13px;
		color: #606266;
	}

	.weekday-pill:hover {
		border-color: #67c23a;
		color: #409eff;
	}

	.weekday-pill.active {
		border-color: #67c23a;
		background: #ecf8f1;
		color: #2d8f47;
		box-shadow: 0 2px 8px rgba(103, 194, 58, 0.2);
	}

	.weekday-pill.isWeekend .weekday-label {
		font-weight: 500;
	}

	.weekend-badge {
		font-size: 11px;
		color: #e6a23c;
		background: #fdf6ec;
		padding: 0 5px;
		border-radius: 4px;
		line-height: 18px;
	}

	.batch-card {
		background: #fafafa;
		border-radius: 8px;
		padding: 12px 14px;
		margin-bottom: 16px;
		border: 1px solid #eee;
	}

	.batch-title {
		font-size: 13px;
		font-weight: 600;
		color: #303133;
		margin-bottom: 10px;
	}

	.batch-row {
		display: flex;
		flex-wrap: wrap;
		align-items: center;
		gap: 10px;
	}

	.batch-label {
		font-size: 13px;
		color: #909399;
		white-space: nowrap;
	}

	.batch-input {
		width: 140px;
	}

	.day-title {
		margin-bottom: 10px;
	}

	.day-title-main {
		font-size: 15px;
		font-weight: 600;
		color: #303133;
		margin-right: 10px;
	}

	.day-title-sub {
		font-size: 12px;
		color: #909399;
	}

	.price-table {
		border-radius: 8px;
		overflow: hidden;
	}
</style>

<style>
	.space-edit-dialog .el-dialog__body {
		padding-top: 12px;
	}
</style>